/*
AB   MK-024
Listens for recharge-subscription or selling plan changes and updates variant prices and savings percentages.
*/

function ceil(num) {
  return Math.ceil(num);
}

function formatPrice(amount) {
  // Format amount (in cents) to money format
  const dollars = (amount / 100).toFixed(2);
  return '$' + dollars;
}

function getForm(prodCard) {
  return prodCard.querySelector(`form[action*="/cart/add"]`);
}

function getSelectedSellingPlanId(prodCard) {
  const form = getForm(prodCard);
  const customSellingPlanInput = form?.querySelector('input[name="selling_plan_0"]');
  if (customSellingPlanInput && customSellingPlanInput.value === 'onetime') {
    return null;
  }
  const sp = form?.querySelector('input[name="selling_plan"], select[name="selling_plan"]');
  const val = sp?.value;
  return val ? Number(val) : null;
}

function extractDoseCount(optionName) {
  // Extract numeric dose count from option label (e.g., "30-count" → 30)
  const normalized = optionName.replace(/–/g, '-').replace(/—/g, '-');
  const parts = normalized.split('-');
  const leftSide = parts[0]?.trim() || '';

  const doseToken = leftSide
    .replace(/\s/g, '')
    .replace(/,/g, '')
    .replace(/\./g, '')
    .replace(/count/gi, '')
    .replace(/per/gi, '')
    .replace(/serving/gi, '');

  const doseCount = parseInt(doseToken, 10);
  return isNaN(doseCount) ? 0 : doseCount;
}

function updateVariantSavings() {
  const variantPickerWrapper = document.querySelectorAll('variant-selects');

  variantPickerWrapper.forEach(variantPicker => {
    const countOptions = variantPicker.querySelectorAll('label[data-option-name*="-count"], label[data-grams-per-serving]');
    const variantKeys = variantPicker.variant_map;

    // If variant_map is not ready, still reveal the elements
    if (!variantKeys) {
      countOptions.forEach((option) => {
        const priceDiv = option.querySelector('.variant-price.mk-024-element');
        if (priceDiv) {
          priceDiv.style.opacity = '1';
        }
        const savingsDiv = option.querySelector('.variant-saving.mk-024-element');
        if (savingsDiv) {
          savingsDiv.style.opacity = '1';
        }
      });
      return;
    }

    const prodCard = variantPicker.closest('.card') || variantPicker.closest('.product__info-wrapper');
    const currentSellingPlan = getSelectedSellingPlanId(prodCard);

    let basePrice = null;
    let baseDoseCount = null;
    let basePricePerDose = null;

    countOptions.forEach((option, index) => {
      const optionName = option.getAttribute('data-option-name');
      const doseCount = extractDoseCount(optionName);

      const optionPrice = [...variantKeys].find(([key]) => key.includes(optionName))?.[1];
      if (!optionPrice) return;

      let currentOptionPrice;
      if (currentSellingPlan) {
        const allocation = optionPrice.selling_plan_allocations?.find(
          i => i.selling_plan_id === currentSellingPlan
        );
        currentOptionPrice = allocation?.price || optionPrice.price;
      } else {
        currentOptionPrice = optionPrice.price;
      }

      // Ensure we have a valid price before proceeding
      if (currentOptionPrice === undefined || currentOptionPrice === null) {
        return;
      }

      // Set base on first iteration
      if (index === 0) {
        basePrice = currentOptionPrice;
        baseDoseCount = doseCount;
        basePricePerDose = baseDoseCount > 0 ? basePrice / baseDoseCount : basePrice;
      }

      // Update variant price (only if changed)
      const priceDiv = option.querySelector('.variant-price.mk-024-element');
      if (priceDiv) {
        const formattedPrice = formatPrice(currentOptionPrice);
        priceDiv.style.opacity = '1';
        if (!priceDiv.textContent.includes(formattedPrice)) {
          priceDiv.textContent = formattedPrice;
        }
      }

      // Find savings element
      const savingsDiv = option.querySelector('.variant-saving.mk-024-element');
      if (!savingsDiv) {
        return;
      }

      // Calculate current price per dose
      const currentPricePerDose = doseCount > 0 ? currentOptionPrice / doseCount : currentOptionPrice;
      const ppd_diff = basePricePerDose - currentPricePerDose;
      const ppd_diff_abs = Math.abs(ppd_diff);
      let ppd_diff_pct = 0;

      if (basePricePerDose > 0) {
        ppd_diff_pct = ceil((ppd_diff_abs / basePricePerDose) * 100);
      }

      // Ensure savings div is visible
      savingsDiv.style.opacity = '1';
      let savingsText = '';
      if (index === 0) {
        savingsText = 'No Savings';
      } else if (ppd_diff > 0) {
        savingsText = `Save ${ppd_diff_pct}%!`;
      } else {
        savingsText = 'No Savings';
      }

      const savingsSpan = savingsDiv.querySelector('.no-savings, .variant-discount');
      if (savingsSpan && !savingsSpan.textContent.includes(savingsText)) {
        savingsSpan.textContent = savingsText;
        // Update class for styling
        if (index === 0) {
          savingsSpan.className = 'variant-discount no-savings';
        } else if (ppd_diff > 0) {
          savingsSpan.className = 'variant-discount';
        } else {
          savingsSpan.className = 'variant-discount no-savings higher-or-equal';
        }
      }
    });
  });
}

function initVariantSavingsDetection() {
  // React immediately to variant changes (mirrors price-per-item.js pattern)
  if (window.subscribe && window.PUB_SUB_EVENTS?.variantChange) {
    window.subscribe(window.PUB_SUB_EVENTS.variantChange, () => {
      requestAnimationFrame(() => {
        setTimeout(updateVariantSavings, 100);
      });
    });
  }

  // Fallback polling to catch any missed updates
  setInterval(updateVariantSavings, 250);
}

document.addEventListener('DOMContentLoaded', () => {
  initVariantSavingsDetection();
  updateVariantSavings();
});
